import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { IApiResponse } from "../../../../@types/api-response.type";
import { FormUsers } from "../components/FormUsers";
import { getUserById } from "../../../../services/api/user/UserService";
import { IUserInformation } from "../../../../@types/user-information.type";

export const UpdateUser: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [user, setUser] = useState<IUserInformation>({} as IUserInformation);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function fechUserById() {
      try {
        setLoading(true);

        if (!id) {
          toast.error("ID do Usuário não fornecido!");
          navigate("/*");
          return;
        }

        const response = (await getUserById(
          id
        )) as IApiResponse<IUserInformation>;

        if (!response.result) {
          toast.error("Usuário não encontrado!");
          navigate("/*");
          return;
        }

        setUser(response.result);
      } catch (error) {
        console.log(error);
        toast.error("Erro ao carregar a Usuário!");
      } finally {
        setLoading(false);
      }
    }

    fechUserById();
  }, [id]);

  return (
    <>
      {loading ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress size={100} />
        </div>
      ) : (
        <div>
          <FormUsers pageType="update" userData={user} />
        </div>
      )}
    </>
  );
};
